<template>
  <div class="referrals-main">
    <div class="referral-card-view">
      <ReferralLinkCard></ReferralLinkCard>
      <ReferralCreditCard></ReferralCreditCard>
      <TotalReferralsCard></TotalReferralsCard>
    </div>
    <div style="height: 32px"/>
    <ReferralGraph/>
    <ReferralHistory></ReferralHistory>
  </div>
</template>


<script>
import ReferralLinkCard from "../../../components/user/referrals/ReferralLinkCard";
import ReferralCreditCard from "../../../components/user/referrals/ReferralCreditCard";
import TotalReferralsCard from "../../../components/user/referrals/TotalReferralsCard";
import ReferralHistory from "../../../components/user/referrals/ReferralHistory";
import ReferralGraph from '../../../components/user/referrals/ReferralGraph.vue'
// apis
import {handleGetReferralDetails} from '../../../service/referral';

export default {
  components: {
    ReferralLinkCard,
    ReferralCreditCard,
    TotalReferralsCard,
    ReferralHistory,
    ReferralGraph
  },
  async mounted() {
    try {
      await handleGetReferralDetails();
    }catch(e){
      console.log(e);
    }
  }
};
</script>

<style scoped>
.referral-card-view {
  display: flex;
  justify-content: space-between;
}

.referrals-main{
    display: flex;
    flex-direction: column;
}

@media only screen and (max-width: 1250px){
  .referral-card-view{
    flex-wrap: wrap !important;
        justify-content: first baseline;

  }
  .referral-link-card, .referral-credit-card, .total-referrals-card{
    max-width: 44% !important;
    width: 44% !important;
    flex: 44% !important;
    margin-bottom: 32px !important;
  }
}

@media only screen and (max-width: 665px){
   .referral-link-card, .referral-credit-card, .total-referrals-card{
    max-width: 100% !important;
    width: 100% !important;
    flex: 100% !important;
    margin-bottom: 32px !important;
  }
}
</style>